export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="py-14 md:py-20">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
            <div className="lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-movie-2-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading font-bold text-xl text-background-50">番茄影视大全</span>
              </div>
              <p className="text-sm text-background-300 leading-relaxed mb-4">
                番茄影视大全提供免费看电视剧、在线看电影不收费、全集免费观看等高清不缓冲的免费影视播放体验，热门综艺免费看。海量资源每日更新，随时随地畅享高清观影。
              </p>
            </div>

            <div>
              <h3 className="font-heading font-semibold text-base text-background-50 mb-4">快速导航</h3>
              <ul className="space-y-2">
                {[
                  { label: '热门专题', href: '#carousel' },
                  { label: '热播榜单', href: '#ranking' },
                  { label: '精彩视频', href: '#media' },
                  { label: '最新动态', href: '#updates' },
                  { label: '分类索引', href: '#index' },
                  { label: '联系我们', href: '#contact' },
                ].map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer no-underline"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="font-heading font-semibold text-base text-background-50 mb-4">内容分类</h3>
              <ul className="space-y-2">
                {['热门电视剧', '院线大片', '人气综艺', '经典动漫', '纪录片频道', '少儿专区'].map((cat) => (
                  <li key={cat}>
                    <a
                      href="#cards"
                      onClick={(e) => {
                        e.preventDefault();
                        document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer no-underline"
                    >
                      {cat}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="font-heading font-semibold text-base text-background-50 mb-4">合作伙伴</h3>
              <p className="text-sm text-background-400 leading-relaxed">
                合作品牌信息即将上线，敬请期待。
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/50 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; 2020-2026 番茄影视大全 fanqieys.com 版权所有
          </p>
          <p className="text-xs text-background-500">
            本站内容仅供学习交流，请于下载后24小时内删除
          </p>
        </div>
      </div>
    </footer>
  );
}